import { Tag } from './tag'

export type { TagProps } from './tag'

export default Tag
